module.exports = ".loader {\n    width: 60px;\n    margin: 0 auto;\n    position: relative;\n    top: 50px;\n}\n\n.card {\n    height: 130px;\n}\n\np {\n    margin-top: 15px !important;\n    text-align: center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.css
// module id = ./src/app/shared/spinner/spinner.component.css
// module chunks = main